var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice",class:{'success':_vm.type=='success','warning':_vm.type=='warning','error':_vm.type=='error'}},[_c('p',{staticClass:"infos"},[_vm._t("noticeTxt")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }